import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() =>
	createStyles({
		applyingText: {
			color: 'transparent'
		},
		applyingSpinner: {
			position: 'absolute'
		}
	})
);

export interface IApplyButtonProps {
	onClick?: () => void;
	applying?: boolean;
	disabled?: boolean;
	large?: boolean;
	changesCount?: number;
	testId?: string;
	label?: string;
}

const ApplyButton: React.FunctionComponent<IApplyButtonProps> = props => {
	const classes = useStyles();
	const changesCount = props.changesCount > 0 ? ` (${props.changesCount})` : '';

	return (
		<button
			className={clsx('rup-btn', 'rup-btn--contained', {
				['rup-btn--loading']: props.applying,
				['rup-btn--lg']: props.large
			})}
			data-test-id={props.testId ?? 'apply-btn'}
			type="button"
			onClick={() => {
				if (props.onClick) {
					props.onClick();
				}
			}}
			disabled={props.disabled}
		>
			<span
				hidden={!props.applying}
				className={clsx('rup-loader rup-loader--sm rup-loader--lighter', {
					[classes.applyingSpinner]: props.applying
				})}
				role="status"
			/>
			<span
				className={clsx({
					[classes.applyingText]: props.applying
				})}
			>
				{props.label ? `${props.label}${changesCount}` : `${localize('Apply')}${changesCount}`}
			</span>
		</button>
	);
};

export default ApplyButton;
